export default __webpack_public_path__ + "static/media/signal-issue.8ea97d2c.jpg";